import { render, staticRenderFns } from "./PanelsList.vue?vue&type=template&id=a84ce870&scoped=true"
import script from "./PanelsList.vue?vue&type=script&lang=js"
export * from "./PanelsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a84ce870",
  null
  
)

export default component.exports